export default "__VITE_ASSET__CaGIqmlI__"